import { SbtiTarget } from 'models/Sbti/sbti.model';

export const TargetTexts = {
  TARGETS_AND_INITIATIVES: 'Climate Target',
  ADD_SCIENCE_BASED_TARGET: 'Add Science Based Target',
  ADD_CUSTOM_TARGET: 'Add Custom Target',
  SBTI_TARGET: 'Climate Performance',
  NO_ORG_CREATED:
    'Create a parent organization, add locations and complete scope to create SBTi Target',
  NAVIGATE_TO_ORG_PAGE: 'Navigate To Organization Page',
  EMPTY_STATE_TITLE: 'Add Climate Target',
  CUSTOM: 'custom',
  CUSTOM_TEXT: 'Custom',
  TAG: 'Custom Target',
  POSSIBLE_TARGET_STATEMENT: 'Possible Target Statement',
  COMMIT_TEXT: ' commits to reduce ',
  EMISSION: ' emissions by ',
  BY: ' % by ',
  BASEYEAR: ' from a base year of ',
  TARGET_STATEMENT: '  42% by 2030 from a base year of 2023.',

  EMPTY_STATE_SUBTITLE:
    'Set a Climate target to guide your journey towards achieving your goals in the coming years.',
  SCIENCE_BASED: 'science_based',
  IS_SME: 'isSME',
  TARGET_COVERAGE: 'targetCoverage',
  TARGET_YEAR: 'targetYear',
  TARGET_TYPE: 'targetType',
  EDIT_TARGET: 'Edit Target',
  CREATE_CUSTOM_TEXT: 'Set A New Custom Target',
  CREATE_TEXT: 'Set A New Target',
  CREATE: 'Create',
  SUBMIT: 'Submit',
  TARGET_CATEGORY: 'targetCategory',
  ALERT_SUB_HEADING_EDIT:
    'Closing the form will result in the loss of data entered in the edit target form and the target will not be updated',
  ALERT_SUB_HEADING:
    'Closing the form will result in the loss of data entered in the create target form and target will not be created.',
};

export const scopeTextFormatter = (text?: string) => {
  return (
    text &&
    text
      .replace(/\bscope1\b/gi, 'Scope 1')
      .replace(/\bscope2\b/gi, 'Scope 2')
      .replace(/\bscope3\b/gi, 'Scope 3')
      .replace(/\bscope1_scope2\b/gi, 'Scope 1 & Scope 2')
  );
};
export const targetFormatter = (text?: string) => {
  return (
    text &&
    text
      .trim()
      .replace(/net_zero/gi, 'Net Zero')
      .replace(/near_term/gi, 'Near Term')
  );
};
const customText = 'custom';
export const getTargetFields = (target?: SbtiTarget) => [
  target?.targetCategory !== customText && {
    label: 'Are you an SME as per SBTi eligibility criteria',
    name: 'isSme',
    value: target?.isSME ? 'Yes' : 'No',
  },
  target?.targetType !== null && {
    label: 'Select Target',
    name: 'targetName',
    value: targetFormatter(target?.targetType),
  },
  {
    label: 'Select Organization',
    name: 'organizationName',
    value: target?.organizationName,
  },
  {
    label: 'Target Coverage',
    name: 'targetCoverage',
    value: scopeTextFormatter(target?.targetCoverage),
  },
  { label: 'Baseline Year', name: 'baselineYear', value: target?.baselineYear },
  { label: 'Target Year', name: 'targetYear', value: target?.targetYear },
  { label: 'Scope 1', name: 'scope1', value: target?.scope1?.toFixed(2) },
  { label: 'Scope 2', name: 'scope2', value: target?.scope2?.toFixed(2) },
  {
    label: 'Total Scope 1 & 2',
    name: 'scope1Scope2',
    value: ((target?.scope1 ?? 0) + (target?.scope2 ?? 0)).toFixed(2),
  },
  {
    label: 'Base Year Emission',
    name: 'baseYearEmission',
    value: target?.baseYearEmission?.toFixed(2),
  },
  {
    label: 'Total Reduction %',
    name: 'totalReduction',
    value: target?.totalReduction?.toFixed(2),
  },
  {
    label: 'Annual Reduction %',
    name: 'annualReduction',
    value: target?.annualReduction?.toFixed(2),
  },
  {
    label: 'Target Year Emissions',
    name: 'targetYearEmission',
    value: target?.totalYearEmissions?.toFixed(2),
  },
  {
    label: 'Notes',
    name: 'notes',
    value: target?.notes,
  },
];
